import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect, useRef } from 'react';
import { Pronunciation } from '../../../../models/Subscription/Pronunciation';
import rootStore from '../../../../stores/rootStore';
import AudioPlaybackIcon from '../../../common/AudioPlaybackIcon';
import Textarea from '../../../common/inputElements/Textarea';

interface IProps {
  pronunciation: Pronunciation;
  language: string;
}

const PronunciationText: React.FC<IProps> = ({ pronunciation: item, language }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const { pronunciationStore } = useContext(rootStore);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = '0px';
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + 'px';
    }
  }, [item.text]);

  const getClassName = () => {
    if (item.isDeleted) {
      return 'deleted';
    } else if (item.textIsModified() || item.isAdded) {
      return 'highlighted';
    }
    return '';
  };

  return (
    <div className='pronunciation-text-wrapper'>
      <Textarea
        ref={textareaRef}
        value={item.text ?? ''}
        changeHandler={(value) => {
          item.text = value;
        }}
        disabled={item.isDeleted}
        placeholder='Type in the original text...'
        className={`text-cell ${getClassName()}`}
      />
      <AudioPlaybackIcon
        text={item.text}
        language={language}
        disabled={item.isDeleted}
        usePronunciation={false}
      />
    </div>
  );
};

export default observer(PronunciationText);
